export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  finish: false,
  error: false,
  dataEnroll: null,
  isFetchingEnroll: false,
  finishEnroll: false,
  errorEnroll: false,
  dataFace: [],
  isFetchingFace: false,
  finishFace: false,
  errorFace: false,
};

export const requestEmployee = (state, action) => {
  return {
    ...state,
    isFetching: true,
  };
};

export const successEmployee = (state, action) => {
  return {
    ...state,
    data: action.data.data,
    finish: true,
    isFetching: false,
    error: false,
  };
};

export const failureEmployee = (state, action) => {
  return {
    ...state,
    data: action.errData,
    finish: true,
    isFetching: false,
    error: true,
  };
};

export const requestEnroll = (state, action) => {
  return {
    ...state,
    isFetchingEnroll: true,
  };
};

export const successEnroll = (state, action) => {
  return {
    ...state,
    dataEnroll: action.data,
    finishEnroll: true,
    isFetchingEnroll: false,
    errorEnroll: false,
  };
};

export const failureEnroll = (state, action) => {
  return {
    ...state,
    dataEnroll: action.errData,
    isFetchingEnroll: false,
    finishEnroll: true,
    errorEnroll: true,
  };
};

export const requestFace = (state, action) => {
  return {
    ...state,
    dataFace: [],
    isFetchingFace: true,
  };
};

export const successFace = (state, action) => {
  return {
    ...state,
    dataFace: action.data,
    isFetchingFace: false,
    errorFace: false,
  };
};

export const failureFace = (state, action) => {
  return {
    ...state,
    dataFace: action.errData,
    isFetchingFace: false,
    errorFace: true,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQ_GET_EMPLOYEE_DATA_REQUESTED":
      return requestEmployee(state, action);
    case "REQ_GET_EMPLOYEE_DATA":
      return successEmployee(state, action);
    case "REQ_GET_EMPLOYEE_DATA_FAILED":
      return failureEmployee(state, action);
    case "REQ_POST_ENROLL_FACE_REQUESTED":
      return requestEnroll(state, action);
    case "REQ_POST_ENROLL_FACE":
      return successEnroll(state, action);
    case "REQ_POST_ENROLL_FACE_FAILED":
      return failureEnroll(state, action);
    case "REQ_GET_ALL_FACE_REQUESTED":
      return requestFace(state, action);
    case "REQ_GET_ALL_FACE_SUCCEEDED":
      return successFace(state, action);
    case "REQ_GET_ALL_FACE_FAILED":
      return failureFace(state, action);
    case "RESET_FACE":
      return INITIAL_STATE;
    default:
      return state;
  }
};
